/* DESIGNSPOT – Oblíbené (wishlist)
   Nepřihlášený zákazník: seznam v prohlížeči (localStorage).
   Přihlášený zákazník: seznam v účtu (metafield custom.wishlist) přes app proxy /apps/wishlist. */
(function () {
  'use strict';

  var KEY = 'ds_wishlist_v1';
  var WL_SYNC_URL = '/apps/wishlist';
  var OWNER_KEY = 'ds_wishlist_owner';
  var customerId = window.dsWishlistCustomer ? String(window.dsWishlistCustomer) : null;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function has(id) {
    id = String(id);
    return read().some(function (i) { return String(i.id) === id; });
  }

  function track(action, item) {
    var payload = {
      product_id: String(item.id),
      product_handle: item.handle,
      product_title: item.title || '',
      price: item.price || null,
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || null
    };
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish(action === 'add' ? 'ds_add_to_wishlist' : 'ds_remove_from_wishlist', payload);
      }
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      if (action === 'add') {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'add_to_wishlist',
          ecommerce: {
            currency: payload.currency,
            value: payload.price,
            items: [{ item_id: payload.product_id, item_name: payload.product_title, price: payload.price }]
          }
        });
      }
    } catch (e) {}
  }

  // ---- Synchronizace s účtem ----
  // Lokální seznam je pracovní kopie. Ze serveru se přebírá jen tehdy, když na tomto
  // zařízení nejsou neodeslané změny (lokální seznam = poslední seznam potvrzený serverem).
  var SYNCED_KEY = 'ds_wishlist_synced';

  function idsOf(list) { return list.map(function (i) { return String(i.id); }); }
  function sameIds(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    var s = {};
    a.forEach(function (x) { s[x] = true; });
    return b.every(function (x) { return s[x]; });
  }
  function readSynced() {
    try {
      var v = JSON.parse(localStorage.getItem(SYNCED_KEY) || 'null');
      return Array.isArray(v) ? v.map(String) : null;
    } catch (e) { return null; }
  }
  function writeSynced(ids) {
    try { localStorage.setItem(SYNCED_KEY, JSON.stringify(ids)); } catch (e) {}
  }
  function hasPending() { return !sameIds(idsOf(read()), readSynced()); }

  var inFlight = false;
  var again = false;
  function push() {
    if (!customerId) return;
    if (inFlight) { again = true; return; }
    inFlight = true;
    var ids = idsOf(read());
    var done = function () {
      inFlight = false;
      if (again) { again = false; push(); }
    };
    try {
      fetch(WL_SYNC_URL, {
        method: 'POST',
        keepalive: true, // dokončí se i při přechodu na jinou stránku
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ ids: ids })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          // za potvrzené se bere jen to, co server opravdu uložil
          if (d && d.ok && Array.isArray(d.ids)) writeSynced(d.ids.map(String));
        })
        .catch(function () {})
        .then(done);
    } catch (e) { done(); }
  }

  function merge(a, b) {
    var seen = {};
    var out = [];
    a.concat(b).forEach(function (i) {
      var id = String(i.id);
      if (seen[id]) return;
      seen[id] = true;
      out.push({ id: id, handle: i.handle, t: i.t || Date.now() });
    });
    return out;
  }

  function initAccount() {
    if (!customerId) return;
    var server = Array.isArray(window.dsWishlistServer) ? window.dsWishlistServer : [];
    var owner = null;
    try { owner = localStorage.getItem(OWNER_KEY); } catch (e) {}

    // první přihlášení na tomto zařízení (nebo starší verze bez potvrzeného stavu): sloučit
    if (owner !== customerId || readSynced() === null) {
      var merged = merge(read(), server);
      write(merged);
      try { localStorage.setItem(OWNER_KEY, customerId); } catch (e) {}
      writeSynced(idsOf(server));
      if (hasPending()) push();
      return;
    }

    // neodeslané změny z minula: lokální seznam se nemaže, jen se znovu odešle
    if (hasPending()) { push(); return; }

    // jinak načíst aktuální stav účtu (změny z jiných zařízení)
    try {
      fetch(WL_SYNC_URL, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !Array.isArray(d.items)) return;
          if (hasPending()) return; // mezitím přibyla lokální změna
          var fresh = d.items.map(function (i) { return { id: String(i.id), handle: i.handle, t: Date.now() }; });
          var changed = !sameIds(idsOf(read()), idsOf(fresh));
          write(fresh);
          writeSynced(idsOf(fresh));
          if (changed) { refresh(); renderPage(); }
        })
        .catch(function () {});
    } catch (e) {}
  }

  function toggle(btn) {
    var item = {
      id: btn.getAttribute('data-wl-id'),
      handle: btn.getAttribute('data-wl-handle'),
      title: btn.getAttribute('data-wl-title'),
      price: parseFloat(btn.getAttribute('data-wl-price')) || null
    };
    var list = read();
    var idx = list.findIndex(function (i) { return String(i.id) === String(item.id); });
    var action;
    if (idx > -1) {
      list.splice(idx, 1);
      action = 'remove';
    } else {
      list.unshift({ id: String(item.id), handle: item.handle, t: Date.now() });
      action = 'add';
    }
    write(list);
    track(action, item);
    push();
    refresh();

    // Na stránce Oblíbené produkt nezmizí hned – jen zešedne (lze vrátit).
    var card = btn.closest('[data-wl-page] .grid__item');
    if (card) card.classList.toggle('wl-removed', action === 'remove');
  }

  function refresh() {
    var list = read();
    var ids = {};
    list.forEach(function (i) { ids[String(i.id)] = true; });
    document.querySelectorAll('[data-wl-id]').forEach(function (b) {
      var on = !!ids[b.getAttribute('data-wl-id')];
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wl-dot]').forEach(function (d) {
      d.classList.toggle('is-visible', list.length > 0);
    });
  }

  function renderPage() {
    var page = document.querySelector('[data-wl-page]');
    if (!page) return;
    var grid = page.querySelector('[data-wl-grid]');
    var empty = page.querySelector('[data-wl-empty]');
    var list = read();
    if (!list.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }
    empty.hidden = true;
    Promise.all(list.map(function (i) {
      return fetch(root + 'products/' + encodeURIComponent(i.handle) + '?view=wl', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    })).then(function (htmls) {
      var missing = [];
      var out = '';
      htmls.forEach(function (h, n) {
        // prázdná odpověď = produkt už není v prodeji (šablona product.wl nic nevypíše)
        if (h && h.replace(/\s/g, '').length > 0) out += h;
        else missing.push(String(list[n].id));
      });
      // Produkty, které už neexistují nebo nejsou v prodeji, ze seznamu tiše odebrat.
      if (missing.length) {
        write(read().filter(function (i) { return missing.indexOf(String(i.id)) === -1; }));
      }
      grid.innerHTML = out;
      if (!out) empty.hidden = false;
      // lazyload obrázků v theme (lazysizes) – nové prvky se načtou samy
      refresh();
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wl-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  }, true);

  function init() {
    initAccount();
    refresh();
    renderPage();
    // Karty načtené později (rychlý náhled, doporučené produkty…) dostanou správný stav srdíčka.
    var timer;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(refresh, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.dsWishlist = { read: read, has: has, refresh: refresh };
})();
